import React, {useContext} from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import NestedMenuItem from "material-ui-nested-menu-item";
import { IconButton } from "@material-ui/core";
import { useMenuClasses, useMenuItemClasses } from './Navigator/TreeContextMenu';
import EditorContext from '../modules/contexts/editor';
import Divider from "@material-ui/core/Divider";
import HamburgerMenu from './ui/HamburgerMenu';

const HeaderMenu = () => {
    const editor = useContext(EditorContext);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const menuClasses = useMenuClasses();
    const menuItemClasses = useMenuItemClasses();

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <HamburgerMenu menuItems={editor.headerMenu} itemSelectHandler={editor.handleHeaderMenuSelect} />
    );
};

export default HeaderMenu;
